// extracted by mini-css-extract-plugin
module.exports = {"tInfo":"tMessage_tInfo__3KSCS","Infotxt":"tMessage_Infotxt__2rgpa","Ficon":"tMessage_Ficon__2mNqD"};